import { useState, type FormEvent } from 'react';
import { ApiError } from '../api/client';
import { useAuth } from '../auth/AuthContext';
import { MfaStep } from './MfaStep';
import { ForgotPasswordForm, ResetPasswordScreen } from './ResetPasswordScreen';

export function LoginScreen() {
  const auth = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [forgot, setForgot] = useState(false);

  if (window.location.pathname === '/reset-hesla') {
    return (
      <main className="login">
        <ResetPasswordScreen />
      </main>
    );
  }

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await auth.login(email, password);
    } catch (err) {
      // Server returns the same body shape for any login failure. We
      // never disclose which field was wrong.
      const msg = err instanceof ApiError ? 'Invalid email or password.' : 'Login failed.';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="login">
      {auth.mfa ? (
        <MfaStep mode={auth.mfa.mode} onDone={auth.completeMfa} onCancel={auth.cancelMfa} />
      ) : forgot ? (
        <ForgotPasswordForm initialEmail={email} onBack={() => setForgot(false)} />
      ) : (
      <form className="login__card" onSubmit={onSubmit}>
        <img className="login__logo" src="/assets/platform1-logo.png" alt="Platform 1" />
        <label className="login__field">
          <span>Email</span>
          <input
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
          />
        </label>
        <label className="login__field">
          <span>Heslo</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={submitting}
          />
        </label>
        {error && (
          <p className="login__error" role="alert">
            {error}
          </p>
        )}
        <button className="login__submit" type="submit" disabled={submitting}>
          {submitting ? 'Přihlašuji…' : 'Přihlásit se'}
        </button>
        <div className="login__links">
          <button type="button" className="login__link" onClick={() => setForgot(true)}>Zapomenuté heslo?</button>
        </div>
      </form>
      )}
      <p className="login__powered">
        <span>Powered by</span>
        <a href="https://dmwk.cz" target="_blank" rel="noopener noreferrer" aria-label="DMWK">
          <img className="login__dmwk" src="/assets/dmwk-logo.png" alt="DMWK" />
        </a>
      </p>
    </main>
  );
}
